(()=>{
 if(window.__cabaneProductPilot)return;window.__cabaneProductPilot=true;
 function sync(preferred){
  const section=document.querySelector('.pe-tech[data-pe-product]');if(!section)return;
  const payload=section.querySelector('[data-pe-variants]'),target=section.querySelector('[data-pe-variant-specs]');if(!payload||!target)return;
  let data;try{data=JSON.parse(payload.textContent);}catch{return;}
  const form=document.querySelector('product-form form[action*="/cart/add"]')||document.querySelector('form[action*="/cart/add"]');
  let id=String(preferred||form?.querySelector('[name="id"]')?.value||new URL(location.href).searchParams.get('variant')||'');
  const picker=document.querySelector('variant-selects');
  if(picker){
   try{
    const variants=JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
    const chosen=[...picker.querySelectorAll('select,input[type="radio"]:checked')].map(el=>el.value);
    if(chosen.length&&chosen.length===variants[0]?.options?.length){
     const match=variants.find(v=>v.options.every((o,i)=>o===chosen[i]));id=match?String(match.id):'unavailable';
    }
   }catch{}
  }
  if(id&&id!==target.dataset.current){target.innerHTML=id==='unavailable'?'<p>Choisis une combinaison de dimensions disponible pour afficher son format.</p>':data[id]||'';target.dataset.current=id;}
 }
 let pending=false;const schedule=()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;sync();});};
 document.addEventListener('change',schedule);window.addEventListener('popstate',schedule);
 if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.variantChange,e=>sync(e.data?.variant?.id));
 const main=document.querySelector('main');if(main)new MutationObserver(schedule).observe(main,{childList:true,subtree:true,attributes:true,attributeFilter:['value']});
 sync();

})();
